/**
 * One vocabulary for subscription state across every purchase surface.
 *
 * Driven by the status from the backend resolver
 * (analystprep-lms/backend/services/subscriptions/resolveSubscriptionStatus.js),
 * so /subscribe, /subscribe/selectPackage and the admin panel cannot disagree —
 * they did: the same cancelled plan read "Cancelled" on one page and
 * "Purchased" on the other.
 *
 * Change the wording here and it changes everywhere.
 */

export const SUBSCRIPTION_BADGE = {
  active: { label: 'Subscribed', tone: 'ok' },
  past_due: { label: 'Payment failed', tone: 'danger' },
  cancelling: { label: 'Cancelled', tone: 'warn' },
  expired: { label: 'Expired', tone: 'danger' },
};

// One-time purchases keep the existing wording.
export const PURCHASED_BADGE = { label: 'Purchased', tone: 'ok' };

/**
 * @param {object|null} subscription the `subscription` object from the API
 *        (null for one-time plans)
 * @returns {{label: string, tone: 'ok'|'warn'|'danger'}}
 */
export const getSubscriptionBadge = (subscription) => {
  if (!subscription || !subscription.status) return PURCHASED_BADGE;
  return SUBSCRIPTION_BADGE[subscription.status] || PURCHASED_BADGE;
};

/** Suffix for the date row: a live subscription renews, a cancelled one runs out. */
export const getSubscriptionDateLabel = (subscription) => {
  if (!subscription || !subscription.status) return 'Expires: ';
  if (subscription.status === 'cancelling') return 'Access until: ';
  if (subscription.status === 'expired') return 'Ended: ';
  return 'Renews: ';
};



// WEBPACK FOOTER //
// ./src/common/subscriptionBadge.js